import React, {Component} from 'react';
//import {Table, Button, ButtonToolbar} from 'react-bootstrap';
import { Button, ButtonToolbar} from 'react-bootstrap';
//import { Router, Route, Switch, Link } from "react-router-dom";
import { FormattedDate, FormattedNumber, } from 'react-intl';
import {AddGastosModal} from './addgastosmodal';
import {EditGastosModal} from './editgastosmodal';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import './SuperResponsiveTableStyle.css';
import { getApi } from '../App';

export class Gasto extends Component {
    
    constructor(props) {
        super (props);
        console.log ('constructor');
    
        this.state={
            gastos: [],
            isLoading: true,
            error: null,
            addModalShow: false,
            editModalShow: false,
            id: props.match.params.id
        }
    }

    componentDidMount () {
        this.refreshList();    
    }

    deleteGasto(idGasto) {
        if ( window.confirm ('Está seguro que desea eliminar el registro?')) {
            getApi().deleteGastos(idGasto)    
                .then(response=>  {
                    if ( response.ok ) {
                        alert('Registro Eliminado correctamente');
                        this.refreshList();
                        return 'Registro eliminado' ;
                    } else {
                        this.setState({error: new Error('Error al recuperar los datos de la API REST...'), isLoading: false});
                    }
                })
                .catch(() => {
                    this.setState({error: new Error('El registro no pudo ser eliminado...'), isLoading: false});
                    console.error('Hubo un error!', this.error);
                });
                
        }

    }

    refreshList() {
        getApi().getGastos( this.state.id)
          .then(data => {this.setState ({gastos: data, isLoading: false })})
          .catch(error => this.setState({error, isLoading: false}));
            
    }        


    formatearFecha(fecha) {
        var options = {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric', second: 'numeric',
            hour12: false,
            timeZone: 'America/Asuncion'
          };

        return new Intl.DateTimeFormat('ES-PY', options).format(fecha);        
        
    }
    render () {
        const {gastos, isLoading, error,
              identificador, idExpediente, fecha, tipoGasto, 
              monto, facturanrostr, proveedor, resposable} = this.state; 
        let addModalClose =() => this.setState({addModalShow: false});
        let editModalClose =() => this.setState({editModalShow: false});

    
        // Sumamos el total de gastos actual
        // usamos 'reduce' para recorrer la lista de gastos y acumular
        //
        console.log ('render');
      
        let gastoIni = gastos[0];
        let TotalGastos = gastos.reduce((total, gasto) => {
                total += gasto.monto; 
                
                return total; }, 0) 
        if ( error ) {
            console.log ('error en el render');
            return (
            <p>Se produjo un error. {error.message}</p>
            );
        }
        if ( isLoading ) {
            return (<p>Cargando datos...</p>) ;
        }
        return (
            
            <div className="container">
                 <div className='mt-4'>
                    <h5>
                        Causa: {gastoIni.caratula}
                    </h5>
                    Total de Gastos a la Fecha:  <b>  <FormattedNumber value={TotalGastos} /> </b>
                </div>
                <ButtonToolbar>
                    <Button variant="primary" 
                        onClick= {()=> this.setState({addModalShow: true})}
                    >
                        Agregar Gastos 
                    </Button> 
                    <AddGastosModal idExpediente={this.state.id}
                      show={this.state.addModalShow}
                      onClose={() => { 
                          this.setState({ addModalShow: false });
                          this.refreshList();
                        }}
                      onHide={addModalClose}
                    />
                </ButtonToolbar>                
                <Table className="mt-4" striped bordered hover size="sm">
                    <Thead>
                    <Tr>
                        <Th>Fecha</Th>
                        <Th>Monto</Th>
                        <Th>Concepto</Th>
                        <Th>Nro. Factura</Th>
                        <Th>Proveedor</Th>
                        <Th>Acciones</Th>
                        
                    </Tr>
                    </Thead>
                    <Tbody>
                    {gastos.map(gasto => (
                        
                        <Tr key={gasto.identificador}>
                        <Td align="left">{
                            <FormattedDate
                            value={gasto.fecha}
                            day="2-digit"
                            month="2-digit"
                            year="numeric"
                            />
                        }</Td>
                        <Td>{
                            <FormattedNumber value={gasto.monto} />
                            }
                        </Td>
                        
                        <Td>{gasto.TipoGasto_Descrip}</Td>
                        <Td>{gasto.facturanrostr}</Td>
                        <Td>{gasto.proveedor}</Td>
                        <Td>
                            <ButtonToolbar>
                                <Button 
                                    className="mr-2" variant="info"
                                    onClick={()=> this.setState ({editModalShow:true,
                                        identificador:gasto.identificador, 
                                        idExpediente:gasto.identexpediente, 
                                        fecha:gasto.fecha, 
                                        tipoGasto:gasto.tipogasto,
                                        monto:gasto.monto, 
                                        facturanrostr:gasto.facturanrostr, 
                                        proveedor:gasto.proveedor,
                                        resposable:gasto.resposable
                                    })}
                                >
                                    Editar
                                </Button>
                                <Button className="mr-2" variant="danger"
                                    onClick ={()=> this.deleteGasto(gasto.identificador)}>
                                        Eliminar
                                    </Button>
                                <EditGastosModal 
                                    show = {this.state.editModalShow}
                                    onHide = {editModalClose}
                                    identificador = {identificador}
                                    idExpediente = {idExpediente}
                                    fecha = {fecha} 
                                    tipoGasto = {tipoGasto}
                                    monto =  {monto}
                                    facturanrostr = {facturanrostr}
                                    proveedor = {proveedor}
                                    resposable = {resposable}
                                    onClose={() => { 
                                        this.setState({ editModalShow: false });
                                        this.refreshList();
                                      }}
                                />
                            </ButtonToolbar>
                        
                        </Td>   
                        </Tr>
                        
                    ))}
                    </Tbody>                    
                </Table>
              
            </div>
           
        );
    }
}